import utils from '@/utils/utils'
import qs from 'query-string'
import { getHllUserInfo } from '@hltn/hll-comment-native-sdk'


/**
 * 打开app新webView
 * 兼容app外跳转，仅支持点评app数据看板下新页面
 * @param {*} roteName H5路由
 * @param {*} query 页面参数
 * @param {*} config 协议其他参数
 */
export function toNextPage(roteName, query = {}, config = { isShowNavigationBar: true, navigationBarTitle: '' }) {
  let queryString = qs.stringify(query)
  queryString = queryString ? `?${queryString}` : ''

  const baseUrl = `${location.origin}${location.pathname}#/`
  const commonUrl = 'dataBoardV2/'
  const url = `${baseUrl}${roteName.includes(commonUrl) ? '' : commonUrl}${roteName}${queryString}`

  if (isHLLReviewApp()) {
    utils.callNative('toNextPage', {
      url,
      ...config
    })
  } else {
    location.href = url
  }
}

/**
 * 打开app的页面
 * @param {*} roteName
 */
export function toOpenPage(roteName, query = {}) {
  utils.callNative(roteName, query)
}

const getIdByGroupName = ({ groupName, groupList }) => {
  for (let i = 0; i < groupList.length; i++) {
    if (groupList[i].groupName === groupName) {
      return groupList[i].groupId
    }
  }
}

export function getIndex(value) {
  const courseTypeList = ['0', '1', '2', '3']
  const index = courseTypeList.findIndex((item) => {
    return item === value
  })
  return index - 1
}
export function setCharts(dom) {
  const courseType = utils.getOptions('courseType')
  let index = getIndex(courseType)
  let names = ['正式课', '专题课', '体验课']
  if (dom && 'dispatchAction' in dom) {
    console.log('===============', { dom })
    if (index !== -1) {
      names.forEach((name, i) => {
        dom.dispatchAction({
          type: index === i ? 'legendSelect' : 'legendUnSelect',
          name,
        })
      })
    } else {
      dom.dispatchAction({
        type: 'legendAllSelect',
      })
    }
  }
}

export function dataAdpter(data) {
  let myData = null
  if ('dataList' in data) {
    myData = data.dataList
  } else if ('dateList' in data) {
    myData = data.dateList
  }
  return myData
}
export function dataSourceAdpter(data) {
  if (!data) return []
  let myData = null
  // 优先返回数据源
  if (data.memberList) {
    myData = data.memberList
  } else if ('dataList' in data) {
    myData = data.dataList
  } else if ('dateList' in data) {
    myData = data.dateList
  }
  if (!myData) return []
  return myData
}

export { getIdByGroupName }

export function parseTime(time, cFormat) {
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
  }
  return format.replace(/{(y|m|d|h|i|s)+}/g, (result, key) => {
    let value = formatObj[key]
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
}

/**
 * 获取url参数
 * 兼容格式1：https://xx.com/?a=111#/path/path2 => {a: 1}
 * 兼容格式1：https://xx.com/#/path/path2?a=111 => {a: 1}
 * @param {*} url 
 * @returns 
 */
export function getUrlQuery(url) {
  if (!url) return {}
  const { search, hash } = new URL(url)
  let queryStr = ''
  const searchIndex = search.indexOf('?')
  const hashIndex = hash.indexOf('?')

  if (searchIndex >= 0) {
    queryStr = search.slice(searchIndex)
  } else if (hashIndex >= 0) {
    queryStr = hash.slice(hashIndex)
  }
  return qs.parse(queryStr)
}

/**
 * 判断数据是否为空
 * @param {*} data 
 * @returns 
 */
export function isEmpty(data) {
  return (data === undefined || data === null)
}

/**
 * 是否画啦啦点评app
 * @returns 
 */
export function isHLLReviewApp() {
  return navigator.userAgent.includes('hualalaReviewApp')
}


// 画啦啦点评app用户信息存储
export function initHLLReviewAppUserStorage() {
  if (isHLLReviewApp()) {
    // 调用原生协议获取用户信息
    getHllUserInfo((res) => {
      if(typeof res === 'object') {
        res && localStorage.setItem('HllUserSensorsInfo', JSON.stringify(res))
      }else{
        res && localStorage.setItem('HllUserSensorsInfo', res)
      }
    })
    const { userId, token } = getUrlQuery(location.href)
    userId && localStorage.setItem('userId', userId)
    token && localStorage.setItem('token', token)
  }
}

/**
 * 获取页面来源
 * @returns 
 */
export function getCheckDetailSource() {
  const { source } = getUrlQuery(window.location.href)
  switch (source) {
    case "1":
      return '综合看板"班级数"'
    case "2":
      return '课程"班级"'
    default:
      return '综合看板"班级数'
  }
}